import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";

const infoHeadTitleList = [
  {
    headTitle: (
      <>
        氏名
        <TkHelpIcon helpMessage="登録されている被共済職員の氏名です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されていない場合があります。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        生年月日
        <TkHelpIcon helpMessage="登録されている被共済職員の生年月日です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        性別
        <TkHelpIcon helpMessage="登録されている被共済職員の性別です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        加入日
        <TkHelpIcon helpMessage="職員の加入年月日です。加入資格（ア～ウ）により加入年月日が異なります。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        配置換え先の施設名
        <TkHelpIcon helpMessage="配置換え先の施設名です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        配置換え先施設の配属日
        <TkHelpIcon helpMessage="配置換え先の施設に配属された日です。" />
      </>
    ),
  },
];

const searchFormList: any = [
  {
    label: "氏名",
    keyword: "name",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
];

const searchFormSchema = {
  name: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

const stepper = ["職員選択/配置換え入力", "配置換え確認", "登録完了"];

export { infoHeadTitleList, searchFormList, searchFormSchema, stepper };
